import z from "zod";

const passwordResetRequestSchema = z.object({
    email: z.string()
        .min(1, "Email nesmí být prázdný")
        .email("Neplatný email")
});

type PasswordResetSchema = z.infer<typeof passwordResetRequestSchema>;

export {passwordResetRequestSchema, type PasswordResetSchema};
